module.exports = __webpack_public_path__ + "img/red-packet-1.153855a4.png";